/* eslint-disable import/no-anonymous-default-export */
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import AuthContext from '../../context/AuthContext';
import walletService from '../../services/walletService';

export default (templateId: number, isModalOpen?: boolean) => {
	const { user } = useContext(AuthContext);
	return useQuery(['walletTiers', user?.tenantId, templateId, isModalOpen], async () => {
		const response = await walletService.getWalletTiers(user?.tenantId, templateId);
		return response.data;
	});
};
